import axios from 'axios';
import { API_URL } from './api';

const cpApi = axios.create({ baseURL: API_URL });

cpApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('cp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

cpApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cp_token');
      localStorage.removeItem('cp_admin');
      window.location.href = '/cp/login';
    }
    return Promise.reject(err);
  }
);

export default cpApi;
